import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, concat, interval, map, Observable, of, switchMap, takeUntil } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class OnlineService {
	constructor(private http: HttpClient) {}

	checkOnline(until: any): Observable<boolean> {
		return concat(
			of(true),
			this.amiup(),
			interval(5000).pipe(
				takeUntil(until),
				switchMap(() => this.amiup())
			)
		);
	}

	private amiup(): Observable<boolean> {
		return this.http.get(`/rest/1.0/amiup`).pipe(
			map(() => true),
			catchError(() => of(false))
		);
	}
}
